<div class="banner_header">
    <div class="col-md-12">
        <h2 style="margin-bottom: 0px;">Admin</h2>
    </div>
</div>

<div class="container download_section pad_btm_size">


    <div class="row">


        <div class="col-md-8 instruc_left">
            <div style="padding: 0px 15px;">
                <h2>Instructions</h2>
                <p> 1. This CBT Grievance readdressal system is for raising your grievance related to CBT Exam and Fee
                    payments.
                </p>
                <p> 2. For Grievance related to CBT Exam, a grievance can be raised only by the Invigilator using his
                    CBT
                    Attendance App login. </p>
                <p> 3. An Invigilator can raise a grievance for the candidates mapped to his centre alone. </p>
                <p> 4. Kindly check the displayed data of the candidate before raising the grievance </p>
                <p> 5. A grievance for a candidate can be raised only once. </p>
                <p> 6. A grievance Ticket ID will be generated for each grievance raised and the status can be tracked
                    in the
                    invigilator login. </p>
                <p> 7. All tickets raised details will be available in the Invigilator login. </p>
            </div>
        </div>

        <div class="col-md-4 instruc_right">

            <!--Raise complaint Login Start-->
            <div>
                <h2>Login with your invigilator credentials</h2>
                <div class="card-body" style="padding: 0px;">
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin()">
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label>Email</label>
                                <input type="text" formControlName="email" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && l.email.errors }" maxlength="50"
                                    (keypress)="omit_email($event)" />
                                <div *ngIf="submitted && l.email.errors" class="invalid-feedback">
                                    <div *ngIf="l.email.errors.required">Email is required</div>
                                    <div *ngIf="l.email.errors.email">
                                        Email must be a valid email address
                                    </div>
                                    <div *ngIf="l.email.errors.pattern">
                                        Enter valid Email address
                                    </div>

                                </div>
                            </div>

                            <div class="form-group col-12">
                                <label>Mobile Number </label>
                                <input type="text" formControlName="mobileno" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && l.mobileno.errors }"
                                    (keypress)="omit_number($event)" maxlength="10" />
                                <div *ngIf="submitted && l.mobileno.errors" class="invalid-feedback">
                                    <div *ngIf="l.mobileno.errors.required">
                                        Mobile no required
                                    </div>
                                </div>
                                <div *ngIf="submitted && l.mobileno.errors" class="invalid-feedback">
                                    <div *ngIf="l.mobileno.errors.pattern">
                                        Mobile no must 10 digit
                                    </div>
                                </div>
                                <!-- <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                          <div *ngIf="f.mobileno.errors.max"> Mobile no must 10 digit</div>
                      </div> -->
                            </div>

                            <div class="form-group col-12">
                                <div class="text-center">
                                    <button class="btn btn-primary mr-1">Login</button>
                                    <!-- <button type="button" (click)="onLoginReset()" class="btn btn-primary mr-1">Login</button> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!--Raise complaint Login End-->
        </div>


    </div>
</div>


<style>
    .banner_header {
        background: #2955a9;
        padding: 10px 0px;
        text-align: left;
        color: #fff;
        margin: 0px;
    }

    .banner_header h2 {
        font-size: 21px;
    }
</style>